import * as vp from 'vopay';

import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import type { AddUsersHandlers } from '../types';
import buildAddUserRows from './buildAddUserRows.helper';
import { usePartnerData } from '@/providers/PartnerData.provider';

const { Box, Button, SubTitle, Table, TextField, Icon, Description, BackButton } = vp;

type AddUsersProps = {
  handlers: AddUsersHandlers;
  defaultValues: vp.CreateAccountUserRequest;
};

type FC = FunctionComponent<AddUsersProps>;
const AddUser: FC = (props: AddUsersProps) => {
  const { handlers, defaultValues } = props;
  const addUserRows = buildAddUserRows();
  const {
    response: { isRoleViewOnly },
  } = usePartnerData();
  return (
    <Formik initialValues={defaultValues} onSubmit={handlers.onAddUser}>
      {({ handleChange, handleBlur, handleSubmit }) => {
        const addUserInputs: vp.TableProps = {
          name: 'add-user-fields',
          variant: 'pair',
          columns: {
            Field: { header: '' },
            Input: { header: '' },
          },
          rows: addUserRows.map(({ label, id }) => ({
            Field: label,
            Input: (
              <TextField
                key={id}
                name={id}
                variant="standard"
                elementLeft={<Icon icon="user" size="md" />}
                onBlur={handleBlur}
                onChange={handleChange}
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <BackButton variant="arrow" backButtonEnabled onClick={handlers.onBack} size="sm" />
            <Box mt="sm" mb="sm">
              <SubTitle subTitle="Add New User" />
            </Box>
            <Box mt="sm" mb="sm">
              <Description>
                {' '}
                Please enter the primary email address for the new user you would like to add. Once the new user account
                has been added, a password will be automatically generated and sent to the email address provided.
              </Description>
            </Box>
            <Table {...addUserInputs} />
            <Box mt="md" jc="fe">
              <Button id="addUserForm-submit" type="submit" label="Add" isDisabled={isRoleViewOnly} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

export default AddUser;
